import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingsService } from './settings.service';
import { Observable} from 'rxjs';
import {
  Response,
  SupplierSearchResponse,
  CountrySearchResponse,
  AccountGop,
  DocListItem
} from '@secca/shared/models/SupplierSearchResponse';
import { ProviderLookup } from '@secca/shared/models/SupplierLookup';
import { ServiceRelations } from '@secca/shared/models/SupplierServicesResponse';
import { CountryElements } from '@secca/shared/models/SupplierSearchCountries';
import { map } from 'rxjs/operators';
import { AccountGopInfo } from '@secca/shared/models/account-gop-info';

@Injectable({
  providedIn: 'root'
})
export class SupplierService extends BaseService {

  constructor(private http: HttpClient, private settingsService: SettingsService) {
    super(settingsService);
  }

  public searchSuppliers(seccaSearchParams: string): Observable<SupplierSearchResponse> {
    return this.http.get<SupplierSearchResponse>(this.baseURL + 'travelcare/search/secca?' + seccaSearchParams, {
       headers: this.jsonHeaders
     });
  }

  public suggesterKeywordSelecterOnSupplierServices(keyword: string): Observable<Response> {
    const apiUrl = this.baseURL + 'travelcare/search/suggest/with_categories?term=' + keyword;
    return this.http.get<Response>(apiUrl, {headers: this.jsonHeaders});
  }

  public searchCountry(code: string): Observable<CountrySearchResponse> {
    return this.http.get<CountrySearchResponse>(`${this.baseURL}travelcare/search/country?code=${code}`, {
      headers: this.jsonHeaders
    });
  }

  public addSupplierToCase(supplierData: ProviderLookup): Observable<number> {
    return this.http.post<number>(this.baseURL + 'providers', supplierData, {
        headers: this.jsonHeaders
      });
  }

  public searchSuppliersServices(): Observable<ServiceRelations> {
    return this.http.get<ServiceRelations>(this.baseURL + 'integration/supplierservices-servicetypes', {
      headers: this.jsonHeaders
    });
  }

  public searchCompetences(): Observable<ServiceRelations> {
    return this.http.get<ServiceRelations>(this.baseURL + 'integration/supplierservices-competences', {
      headers: this.jsonHeaders
    });
  }

  public getSupplierFromCreditor(creditorId: string): Observable<SupplierSearchResponse> {
    return this.http.get<SupplierSearchResponse>(this.baseURL +
      'travelcare/search/supplier/creditor/' + creditorId, { headers: this.jsonHeaders });
  }

  public getSupplierFromAccount(accountId: string): Observable<SupplierSearchResponse> {
    return this.http.get<SupplierSearchResponse>(this.baseURL +
      'travelcare/search/supplier/account/' + accountId, { headers: this.jsonHeaders });
  }

  countryNameAndAlpha2Api(): Observable<CountryElements> {
    return this.http.get<CountryElements>(this.baseURL + 'integration/countries', {
      headers: this.jsonHeaders
    });
  }

}
